import {useEffect, useState} from 'react';
// import {forwardRef, useCallback, ReactNode, CSSProperties, ComponentType} from 'react'
// import 'overlayscrollbars/overlayscrollbars.css';
// import {OverlayScrollbars} from 'overlayscrollbars';
import type {NormalizedProps as StyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled} from '@yosmanyga/web-style'
import {BufferListProps} from '@yosmanyga/primitive-ui-spec'
import Container from './Container'

// const CustomScrollbars = forwardRef<OverlayScrollbars, {style?: CSSProperties, className?: string, children: ReactNode}>(({style, className, children, ...props}, ref) => {
//     const refSetter = useCallback((scrollbarsRef: OverlayScrollbars) => {
//         if (!scrollbarsRef) {
//             return
//         }
//
//         const instance = scrollbarsRef.osInstance()
//
//         if (!instance) {
//             return
//         }
//
//         const customViewport = instance.getElements().viewport
//
//         for (const key in props) {
//             if (!Object.prototype.hasOwnProperty.call(props, key)) {
//                 continue
//             }
//
//             customViewport.setAttribute(key, props[key as keyof typeof props])
//         }
//
//         if (ref != null && typeof ref !== 'function') {
//             ref.current = customViewport
//         }
//     }, [ref])
//
//     return <OverlayScrollbars
//         // ref={refSetter}
//         style={style}
//         className={className}
//     >
//         {children}
//     </OverlayScrollbars>
// })

const BufferList = <T, >({
  init, data, render,
  start, end,
  ...props
}: BufferListProps<T> & StyleProps) => {
  const [Virtuoso, setVirtuoso] = useState<any>(null);

  useEffect(() => {
    const loadVirtuoso = async () => {
      const { Virtuoso } = await import('react-virtuoso');
      setVirtuoso(() => Virtuoso);
    };

    (async () => {
      await loadVirtuoso()
    })();
  }, []);

  if (!Virtuoso) {
    return null; // or a loading spinner
  }

  let component;

  const common = {
    data: data,
    itemContent: (index: number, item: T) => {
      return render(item, index)
    },
    components: {
      // Scroller: CustomScrollbars as unknown as ComponentType // TODO
    },
  }

  if (start) {
    component = <Virtuoso
      firstItemIndex={start.first}
      initialTopMostItemIndex={start.top}
      startReached={start.onReached}
      {...common}
    />
  } else if (end) {
    component = <Virtuoso
      endReached={end && end.onReached}
      {...common}
    />
  }

  return <Container
    {...props}
  >
    {component}
  </Container>
}

const StyledBufferList = styled(BufferList)`
  ${({margin}) => SpacialFn.compileMargin(margin)}
  ${({width}) => SpacialFn.compileWidth(width)}
  ${({height}) => SpacialFn.compileHeight(height)}
` as typeof BufferList

export default StyledBufferList
